export const BOOSTED_SPACING = '4';
export const BOOSTED_GROUP_SIZE = '1';
export const BOOSTING_STATISTICS_CACHED_DATA_STALE_TIME = 300000; // 5 min
export const DEFAULT_ALL_LISTINGS_PAGE_SIZE = 10;
export const BOOSTING_SELECTION_LIMIT = 99;
